import { useHistory } from "react-router-dom";

import { isAuthPath, storeNext } from "../Utilities/Auth/loginRedirect";
import { URLS } from "../Utilities/Maps";
import { useIsDesktopApp } from "./useIsDesktopApp";

const { REACT_APP_BASE_URL } = process.env;

export type RiotLinkReferrer =
  | "CONNECTED_ACCOUNTS"
  | "CLIP_SURFACE"
  | "RELINK_PROMPT";

export const useRiotLink = () => {
  const { isDesktop } = useIsDesktopApp();
  const history = useHistory();

  const link = (
    referrer: RiotLinkReferrer,
    options?: { reconnect?: boolean },
  ) => {
    const reconnectParam = options?.reconnect ? "&reconnect=1" : "";
    if (isDesktop) {
      window.parent.postMessage(
        {
          type: "openLink",
          link: `${REACT_APP_BASE_URL}${URLS.AUTH_ROUTES.RIOT}?flow=link&referrer=DESKTOP_APP${reconnectParam}`,
        },
        "*",
      );
      return;
    }

    if (options?.reconnect) {
      const { pathname, search } = window.location;
      if (!isAuthPath(pathname)) {
        try {
          storeNext(pathname + search);
        } catch {
          // storage unavailable: the user still reaches the link flow
        }
      }
    }

    history.push(
      `${URLS.AUTH_ROUTES.RIOT}?flow=link&referrer=${referrer}${reconnectParam}`,
    );
  };

  return { link };
};
